export class Modal
{
    constructor(text='', closeButton=false, addClass)
    {
        if(typeof HTMLDialogElement === 'function')
        {
            this.native = true;
            this.dialog = document.createElement('dialog');
            this.dialog.classList.add('w__modal');
            document.body.appendChild(this.dialog);
            this.dialog.showModal();
        }
        else
        {
            document.body.classList.add('mod--blur');
            this.native = false;
            this.dialogContainer = document.createElement('div');
            this.dialogContainer.classList.add('w__modal--container');
            this.dialog = document.createElement('div');
            this.dialog.classList.add('w__modal');
            this.dialogContainer.appendChild(this.dialog);
            document.body.appendChild(this.dialogContainer);
        }

        this.add_textElement(text);

        if(closeButton === true)
        {
            const close = document.createElement('button');
            close.classList.add('w__button');
            close.classList.add('w__modal--close');
            close.addEventListener('click', () =>
            {
                this.remove();
            });
            this.dialog.classList.add('mod--close');
            this.dialog.appendChild(close);
        }

        if(addClass)
        {
            this.dialog.classList.add(addClass);
        }
    }

    add_textElement(text, clear=false)
    {
        if(this.dialog && text)
        {
            if(clear === true)
            {
                this.dialog.innerHTML = '';
            }

            const div = document.createElement('div');
            div.classList.add('w__modal--text');
            div.innerHTML = text;
            this.dialog.appendChild(div);
            return div;
        }
    }

    remove()
    {
        if(this.dialog)
        {
            if(this.native === true)
            {
                this.dialog.close();
                this.dialog.remove();
            }
            else
            {
                document.body.classList.remove('mod--blur');
                this.dialogContainer.remove();
            }
        }
    }
}
